import { RawDataFormat } from '../enum/RawDataFormat';
import { GoldenRecordSubTypePatternDto } from './GoldenRecordSubTypePatternDto';
import { Exchange } from '../enum/Exchange';
import { OperationRuleDto } from './OperationRuleDto';
import { IsObject, IsOptional, IsString, Validate, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';
import { GoldenRecordExchangePatternValidator } from '../../service/GoldenRecordExchangePatternValidator';

export class GoldenRecordExchangeConfigDto {

  @IsString()
  exchange: string;
  @IsString()
  exchangeEnum: Exchange;
  @IsString()
  recordType: string;
  @IsString()
  rawDataFormat: RawDataFormat;
  @Validate(GoldenRecordExchangePatternValidator)
  pattern: Array<string> | Record<string, Array<GoldenRecordSubTypePatternDto>>;

  @IsOptional()
  @IsObject()
  @ValidateNested({ each: true })
  @Type(() => OperationRuleDto)
  rules?: Record<string, OperationRuleDto>;
}
